import { render } from "./ApiManageDetail.vue?vue&type=template&id=16d09c3a&scoped=true"
import script from "./ApiManageDetail.vue?vue&type=script&lang=js"
export * from "./ApiManageDetail.vue?vue&type=script&lang=js"

import "./ApiManageDetail.vue?vue&type=style&index=0&id=16d09c3a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d09c3a"]])

export default __exports__